<template>
  <div id="app">
    <disclaimer-window></disclaimer-window>
    <header-container></header-container>
    <body-container id="body"></body-container>
    <footer-container></footer-container>
  </div>
</template>

<script>
import BodyContainer from './Containers/BodyContainer'
import DisclaimerWindow from './Dialogs/DisclaimerWindow'
import FooterContainer from './Containers/FooterContainer'
import HeaderContainer from './Containers/HeaderContainer'

export default {
  name: 'App',

  components: {
    BodyContainer,
    DisclaimerWindow,
    FooterContainer,
    HeaderContainer
  },

  created () {
    // Load GeoJSON Shapes
    this.$store.dispatch('loadOpoShapes')
    this.$store.dispatch('loadUnosShapes')
    this.$store.dispatch('loadStateShapes')

    // Load records
    this.$store.dispatch('loadRecords')

    // Load TxCenters markers. Hospitals markers will be
    // loaded by loadRecords
    this.$store.dispatch('loadTxCenters')

    // Load data used by QueryPanel
    this.$store.dispatch('loadQueryPanelData')
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

#body {
  flex-grow: 1;
  position: relative;
}

.popup-bubble-anchor {
  border: 1px solid #000;
  background-color: #fff;
  padding: 6px;
  font-size: .9rem;
}

.popup-bubble-content-title {
  font-weight: bold;
}

.popup-bubble-content-stat { }

.popup-bubble-content-stat-value {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue